import { render } from "./GenericAccordion.vue?vue&type=template&id=20a8aace&scoped=true"
import script from "./GenericAccordion.vue?vue&type=script&lang=js"
export * from "./GenericAccordion.vue?vue&type=script&lang=js"

import "./GenericAccordion.vue?vue&type=style&index=0&id=20a8aace&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a8aace"]])

export default __exports__